/* @ngInject */
export default function SearchBarController($scope, $timeout, $document, $translate, $uibModal, SearchExecutorService, CacheService, UniquePartModelService, __env) {
    $scope.toggleResetIcon = false;
    $scope.toggleSearchIcon = true;
    $scope.isSearchOpened = false;
    $scope.isLogoHidden = false;

    $scope.$watch(
        function () {
            return CacheService.getOriginalQueryInput();
        },
        function (newValue) {
            $scope.searchBox = newValue;
        }
    );

    $scope.openSearch = function () {
        if (!$scope.isSearchOpened && !$scope.isLogoHidden) {
            $scope.isLogoHidden = true;
        }
        $scope.isSearchOpened = !$scope.isSearchOpened;
    };

    $scope.closeSearchForMobile = function () {
        $scope.isSearchOpened = false;
    };

    $scope.init = function () {
        $scope.openSearch();
        if ($document[0].addEventListener) {
            $document[0].addEventListener('scroll', function (e) {
                $timeout(function () {
                    var scrollingElement;
                    if (e.target.scrollingElement) {
                        scrollingElement = e.target.scrollingElement;
                    } else {
                        scrollingElement = $scope.getScrollingElement();
                    }
                    if (scrollingElement.scrollTop > 0) {
                        $scope.$apply($scope.closeSearchForMobile);
                    }
                }, 300);
            });
        } else {
            $document[0].attachEvent('scroll', function (e) {
                $timeout(function () {
                    var scrollingElement;
                    if (e.target.scrollingElement) {
                        scrollingElement = e.target.scrollingElement;
                    } else {
                        scrollingElement = $scope.getScrollingElement();
                    }
                    if (scrollingElement.scrollTop > 0) {
                        $scope.$apply($scope.closeSearchForMobile);
                    }
                }, 300);
            });
        }
    };

    $scope.getScrollingElement = function () {
        var d = document;
        return d.documentElement.scrollHeight > d.body.scrollHeight &&
        d.compatMode.indexOf('CSS1') === 0 ?
            d.documentElement :
            d.body;
    };

    $scope.isNew = () => {
        return new Date( __env.visualSearchFreshness ).getTime() > Date.now();
    };

    $scope.init();

    $scope.transitionEnded = function () {
        //console.log("transitionEnded");
        if (!$scope.isSearchOpened && $scope.isLogoHidden) {
            //console.log("show logo");
            $scope.isLogoHidden = false;
        }
    };

    $scope.checkButtonState = function (string) {
        if (string) {
            $scope.toggleResetIcon = true;
            $scope.toggleSearchIcon = false;
        } else {
            $scope.toggleResetIcon = false;
            $scope.toggleSearchIcon = true;
        }
    };

    $scope.resetSearch = function () {
        $scope.searchBox = null;
        $scope.checkButtonState($scope.searchBox);
        // The search box element is focused by default. So we need to retain focus even after the input is cleared.
        document.getElementById('search-box').focus();
    };

    $scope.queryByRaw = function () {
        if ($scope.searchBox) {

            if ($scope.searchBox.length >= 2) {
                // Only store original input after it's considered a valid search.
                CacheService.storeOriginalQueryInput($scope.searchBox);
                // This is a little weird, but we want to remove the comparison via the reference we are kicking around.
                UniquePartModelService.removeComparison(UniquePartModelService.getFauxUniquePartObj());
                SearchExecutorService.searchKeyWordsBySleuth($scope.searchBox);
            }
        }
    };

    $scope.dismissModal = function () {
        $modalInstance.dismiss('cancel');
    };
}
